"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4240],{

/***/ 34240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionLogos": function() { return /* binding */ SectionLogos; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55022);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75762);



const StyledSectionWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .SectionWrapper */ .Uq, {
    color: "$white",
    display: "grid",
    justifyItems: "center",
    gap: "$40",
    paddingTop: "$64",
    containerSpace: "small",
    maxWidth: "$maxWidthDesktop",
    marginInline: "auto",
    "@lg": {
        paddingTop: "$96"
    }
});
const Title = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("h2", {
    textAlign: "center",
    projectFont: "heading07",
    letterSpacing: "-0.01em"
});
const LogosList = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("ul", {
    listStyle: "none",
    margin: 0,
    padding: 0,
    width: "100%",
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    justifyItems: "center",
    alignItems: "center",
    paddingBlock: "$8",
    rowGap: "$64",
    "@md": {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        rowGap: "$32",
        columnGap: "$48"
    }
});
const LogoItem = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("li", {
    position: "relative",
    maxWidth: "100%",
    lin: {
        height: [
            20,
            30
        ]
    }
});
const getLogoAspectRatio = (image)=>{
    const payload = image === null || image === void 0 ? void 0 : image.mediaPayload;
    if ((payload === null || payload === void 0 ? void 0 : payload.type) !== "sanity-image") {
        return undefined;
    }
    const { width , height  } = payload.image;
    return width && height ? "".concat(width, " / ").concat(height) : undefined;
};
const SectionLogos = (param)=>{
    let { title , logos , spacing , topBorder  } = param;
    if (!logos || logos.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledSectionWrapper, {
        type: spacing || "DEFAULT",
        topBorder: topBorder,
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LogosList, {
                children: logos.map((logo)=>{
                    const aspectRatio = getLogoAspectRatio(logo.image);
                    if (!logo.image || !aspectRatio) {
                        return null;
                    }
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LogoItem, {
                        css: {
                            aspectRatio
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Media */ .pU, {
                            ...logo.image,
                            layout: "fill",
                            objectFit: "contain",
                            sizes: "250px",
                            disablePlaceholderBackground: true
                        })
                    }, logo._key);
                })
            })
        ]
    });
};


/***/ })

}]);